module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-EC_1.20fcd01e.jpg";